import * as React from 'react';

export default function Academia({
  className,
  viewBox = '0 0 24 24',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="25" height="24" viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Academic cap">
        <g id="Icon">
          <path
            d="M13.2231 2.49742C12.9212 2.36805 12.5795 2.36805 12.2777 2.49742L3.87769 6.09742C3.43647 6.28651 3.15039 6.72036 3.15039 7.20039C3.15039 7.68042 3.43647 8.11427 3.87769 8.30336L7.05084 9.66329C7.16623 9.53255 7.31087 9.42607 7.47769 9.35457L12.2777 7.29743C12.8868 7.03636 13.5923 7.31855 13.8534 7.9277C14.1144 8.53686 13.8322 9.24231 13.2231 9.50338L9.95041 10.906L12.2777 11.9034C12.5795 12.0327 12.9212 12.0327 13.2231 11.9034L21.6231 8.30336C22.0643 8.11427 22.3504 7.68042 22.3504 7.20039C22.3504 6.72036 22.0643 6.28651 21.6231 6.09742L13.2231 2.49742Z"
            fill="#98989F"
          />
          <path
            d="M4.72244 11.2765L6.75039 12.1456V17.0676C6.33907 16.9743 5.91885 16.9045 5.49124 16.8596C4.92752 16.8005 4.48203 16.355 4.42292 15.7913C4.37495 15.3338 4.35039 14.8696 4.35039 14.4002C4.35039 13.3244 4.47928 12.2782 4.72244 11.2765Z"
            fill="#98989F"
          />
          <path
            d="M11.9103 19.8874C11.1029 19.0958 10.1724 18.4305 9.15039 17.9225V13.1742L11.3323 14.1093C12.2379 14.4974 13.2629 14.4974 14.1685 14.1093L20.7783 11.2765C21.0215 12.2782 21.1504 13.3244 21.1504 14.4002C21.1504 14.8696 21.1258 15.3338 21.0779 15.7913C21.0188 16.355 20.5733 16.8005 20.0095 16.8596C17.5221 17.1204 15.2853 18.2259 13.5904 19.8874C13.1238 20.3448 12.377 20.3448 11.9103 19.8874Z"
            fill="#98989F"
          />
          <path
            d="M7.95039 21.6004C8.61313 21.6004 9.15039 21.0631 9.15039 20.4004V17.9225C8.39602 17.5476 7.5918 17.2584 6.75039 17.0676V20.4004C6.75039 21.0631 7.28765 21.6004 7.95039 21.6004Z"
            fill="#98989F"
          />
        </g>
      </g>
    </svg>
  );
}
